import { type License } from '@lved/shared-core/types/license-types';
import { CommandContribution, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import { MANAGE_MENU } from '@theia/core/lib/common/menu/menu-types';
import { injectable } from '@theia/core/shared/inversify';

export const LvglLicenseDebugCommands = {
    SIMULATE_GRACE_EXPIRED: {
        id: 'lvgl.license.debug.simulateGraceExpired',
        label: 'Simulate Offline Grace Expired'
    }
} as const;

const isDevBuild = (): boolean => (window.LVGL_EDITOR_VERSION || '').includes('dev');

@injectable()
export class LicenseDebugContribution implements CommandContribution, MenuContribution {
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(LvglLicenseDebugCommands.SIMULATE_GRACE_EXPIRED, {
            execute: async () => {
                const { useLicenseStore } = await import('@lved/ui');
                const state = useLicenseStore.getState();
                const fallbackLicense: License = {
                    id: 'debug-offline-license',
                    displayName: 'Debug Offline License',
                    seatAvailable: true,
                    expired: false,
                    licenseTier: 'Platform'
                };

                useLicenseStore.setState({
                    offline: true,
                    selectedLicense: state.selectedLicense?.id ? state.selectedLicense : fallbackLicense,
                    inGracePeriodUntil: Date.now() - 60_000
                });

                await useLicenseStore.getState().validateLicense();
            },
            isVisible: () => isDevBuild()
        });
    }

    registerMenus(menus: MenuModelRegistry): void {
        if (!isDevBuild()) return;
        menus.registerMenuAction(MANAGE_MENU, {
            commandId: LvglLicenseDebugCommands.SIMULATE_GRACE_EXPIRED.id,
            label: LvglLicenseDebugCommands.SIMULATE_GRACE_EXPIRED.label,
            order: '99'
        });
    }
}
